// extracted by mini-css-extract-plugin
export default {};
    if(module.hot) {
      // 1793340217736
      var cssReload = require("/home/vsts/work/1/s/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  